import { createContext } from 'react';
import type { OrganisationFilterContextValue } from './organisationTypes';

export const OrganisationFilterContext = createContext<OrganisationFilterContextValue | undefined>(
  undefined,
);
